export const IA = 'insurance-agents'
export const LO = 'loan-officers'
export const REA = 'real-estate-agents'
export const TA = 'title-agents'

export const LEGACY_REA = 'realestate'
